import React from 'react';

import CMSHTML from '../../../../../CMSHTML/CMSHTML';
import type { Props } from '../../TopHeader';

import styles from './RegulatoryHeaderCZ.scss';

const RegulatoryHeaderCZ: React.FC<Props> = ({
  regulatory_header: [
    {
      texts: [{ content }]
    }
  ]
}) => (
  <div className={styles.regulatoryHeader}>
    <CMSHTML content={content} />
  </div>
);

export default RegulatoryHeaderCZ;
